import {request, _urlBonusCards} from "../api";
import {BONUS_CARD_CONSTS, UTIL_CONSTS} from "../constants";
import swal from "sweetalert";
import {LIMIT_GET_PROMO_CODES} from "../../constants/constLimitCounts";
import {history} from "../../configs/history";
import {notificationSuccess} from "../../components/uiElements/Notifications";

export const GetBonusCards = ({
                                  reset = true,
                                  offset = 0,
                                  userId = null,

                                  text = null,
                                  limit = LIMIT_GET_PROMO_CODES,
                              } = {}) => {
    let url = `${_urlBonusCards}?offset=${offset}&limit=${limit}`;
    userId && (url += `&userId=${userId}`);
    text && (url += `&text=${text}`);
    const requestData = {
        url,
        token: true,
        method: "GET",
    };

    return dispatch => {
        reset && dispatch({type: UTIL_CONSTS.START_LOADING});
        return request(requestData)
            .then(({data}) => {
                data && dispatch({
                    type: BONUS_CARD_CONSTS.GET_BONUS_CARDS,
                    payload: {
                        data: data,
                        userId,
                        reset,
                        hasMore: data.length === limit
                    }
                });
                return data
            }).finally(() => {
                reset &&  dispatch({
                    type: UTIL_CONSTS.END_LOADING
                })
            })
    }
};

export const AddBonusCard = (data) => {
    const requestData = {
        url: _urlBonusCards,
        token: true,
        method: "POST",
        data,
    };

    return dispatch => {
        return request(requestData)
            .then(({data}) => {
                notificationSuccess({
                    description: "Բոնուս քարտը հաջողությամբ ստեղծվեց!"
                })
                history.push('/bonusCards')
            })
    }
};

export const DeleteBonusCard = (id) => {
    const requestData = {
        url: `${_urlBonusCards}/${id}`,
        token: true,
        method: "DELETE",
    };

    return dispatch => {
        return request(requestData)
            .then(({data}) => {
                dispatch({
                    type: BONUS_CARD_CONSTS.DELETE_BONUS_CARD,
                    payload: id
                });
                notificationSuccess({
                    description: "Բոնուսի Քարտը հաջողությամբ ջնջվեց!"
                })
            })
    }
};
